import type { FC } from "react";
import styled from "styled-components";
import { RelevancyScore } from "pro-features/components/RelevancyScore/src/RelevancyScore";
import type { ITableCellProps } from "../interfaces/ITableCellProps";

const CellWrapper = styled.div`
    margin: 5px auto 0 auto;
    max-width: 60px;
`;
export const RelevancyCell: FC<ITableCellProps> = ({ value }) => {
    return (
        <CellWrapper>
            <RelevancyScore
                maxBullets={5}
                bullets={value}
            />
        </CellWrapper>
    );
};

RelevancyCell.displayName = "RelevancyCell";
